var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "control-overlay",
      class: _vm.controlActive ? "control-active" : "control-inactive"
    },
    [
      _c(
        "keep-alive",
        [
          _vm.playerState === "buffering"
            ? _c("half-circle-spinner", {
                attrs: { "animation-duration": 1000, size: 60, color: "white" }
              })
            : _vm.playerState !== "complete"
            ? _c("VsIcon", {
                key: _vm.playerState,
                staticClass:
                  "\n        control-overlay__feedback\n        control-overlay__item\n      ",
                class: _vm.showOnlyOnHover ? "show-on-hover" : "",
                attrs: { icon: _vm.iconActions.icon },
                nativeOn: {
                  click: function($event) {
                    return _vm.iconActions.action($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }